<ng-container *ngIf="this.isInitialized">
  <ng-container *ngIf="__ResultLiveData | async as __liveData">
    <div *ngIf="__liveData.length == 0" class="no-live-events">{{ 'no_live_events' | t }}</div>
  </ng-container>
  <div class="live-bar-container-mobile">
    <div class="live-bar-left">{{ this._DataHelper.selectedStoryItem?.sportName }} Live</div>
    <div class="live-bar-right">{{ this._DataHelper.comboSelectedOdd.OddNameLong | t }}</div>
  </div>

  <ng-container *ngFor="let dnm of __ResultLiveData | async | slice : 0 : sliceCount; index as i; last as lastItem; trackBy: pairWithMatchID">
    <div class="match-row-header" *ngIf="dnm.type === 'TournamentName'">
      <image-loader-utils [url]="dnm.IsoName == null ? 'un' : dnm.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
      &nbsp;&nbsp;{{ dnm.TournamentName }}
    </div>
    <ng-container *ngIf="dnm.type !== 'Sport'">
      <match-r
        *ngIf="dnm.type === 'Match'"
        (addOdd)="addOddListener($event)"
        (eventDetailEventId)="eventDetailEventIdListener($event)"
        [_selectedOdds]="_selectedOdds"
        [_d]="dnm"
        [oddType]="oddLiveMarketingValue"
        [_sportName]="dnm.SportNameOriginal"
        [_isLive]="dnm.isLive"
        [_activeOddType]="oddLiveMarketingValue"></match-r>
      <ng-container *ngIf="eventDetailEventId != 0 && (dnm.MatchId == eventDetailEventId || dnm.EventId == eventDetailEventId) && dnm.isLive === true">
        <liveeventdetail-component [showLiveList]="false" [eventIdByInput]="eventDetailEventId"></liveeventdetail-component>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
